var userAgent = navigator.userAgent || navigator.vendor || window.opera;

export const isWindows = () => {
  if (/windows phone/i.test(userAgent)) {
    return true;
  }
};
export const isAndroid = () => {
  if (/android/i.test(userAgent)) {
    return true;
  }
};
export const isIos = () => {
  if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    return true;
  }
};

export const DeviceHelper = () => {
  // Windows Phone must come first because its UA also contains "Android"
  if (/windows phone/i.test(userAgent)) {
    return 'Windows Phone';
  }

  if (/android/i.test(userAgent)) {
    return 'Android';
  }

  // iOS detection from: http://stackoverflow.com/a/9039885/177710
  if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    return 'iOS';
  }
  return 'unknown';
};
